import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nModule } from 'haba-core';
import { InvoiceDownloadComponent } from './invoice-download.component';
import { FormFieldsModule } from '@app/base-components';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    FormFieldsModule,
    RouterModule.forChild([
      {
        path: 'rechnungskopie',
        component: InvoiceDownloadComponent,
      },
    ]),
    InvoiceDownloadComponent,
  ],
  exports: [InvoiceDownloadComponent],
})
export class InvoiceDownloadModule {}
